"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @trackcomponent
 * @optimized using svgo:^3.0.2
 */
export const Shopify = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M19.255 4.416c.097 0 .193.077.213.192l.466 3.144c.755 5.09 2.16 14.576 2.174 14.59l-6.38 1.581L1 21.379S2.773 7.788 2.831 7.307c.077-.636.097-.655.771-.867.02-.02.945-.309 2.275-.714.154-1.021.656-2.332 1.311-3.373C8.113.869 9.27.04 10.427.001c.597-.019 1.098.174 1.484.598q.016.028.038.048a.2.2 0 0 1 .039.048c.077-.019.135-.019.193-.019.887 0 1.638.52 2.14 1.484.154.309.27.598.347.848.443-.135.713-.212.713-.212.096-.038.385-.077.52.058s1.562 1.523 1.562 1.523 1.696.039 1.792.039m-5.878-1.007q.292-.093.558-.17c-.193-.597-.617-1.58-1.484-1.753.27.694.347 1.522.347 2.1q.297-.086.58-.177m-2.41.746q.537-.166 1.04-.318c.02-.655-.058-1.6-.405-2.274-.327.154-.616.404-.828.617-.54.597-1.003 1.503-1.234 2.409.48-.142.96-.29 1.426-.434m.173-3.21a1.3 1.3 0 0 0-.694-.173C8.653.83 7.092 3.625 6.686 5.476c.618-.187 1.29-.393 1.963-.598l.062-.02c.231-1.175.79-2.409 1.523-3.199.289-.308.597-.54.906-.713m.289 9.523.732-2.775s-.636-.328-1.889-.232c-3.238.193-4.703 2.468-4.568 4.704.097 1.493.978 2.117 1.749 2.664.603.428 1.139.808 1.18 1.519.02.385-.23.944-.905.983-1.041.077-2.333-.906-2.333-.906l-.5 2.12s1.29 1.388 3.642 1.234c1.947-.116 3.297-1.677 3.162-3.971-.117-1.762-1.357-2.556-2.334-3.183-.638-.408-1.163-.745-1.194-1.231 0-.232 0-1.138 1.446-1.234a4 4 0 0 1 1.812.308"
    fill="#333"
    clipPath="url(#clip0_1737_494)"
  />,
  "Shopify",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
